// Third party
import { createSlice } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import { reducers } from './reducers';

// Data
import { PERSIST_KEYS, STORE_SLICES } from '../../utils/enums';

// Types
import { IRootState } from './types';

const initialState: IRootState = {
  platformData: {} as IRootState['platformData'],
  passwordValidation: {
    isUpperChar: null,
    isLowerChar: null,
    isSpecialChar: null,
    isEightChar: null,
    isMaxChar: null,
    isPasswordVerify: null,
  },
  isOpenDrawer: true,
  isOpenPagesNav: false,
  isOpenRangePicker: false,
  isOpenReleaseNav: false,
  selectedFilterItems: {} as IRootState['selectedFilterItems'],
  isPrintMode: false,
  selectedLanguage: null,
  isOpenPricingDialog: false,
};
export const slice = createSlice({
  name: STORE_SLICES.COMMON,
  initialState,
  reducers,
});
const commonActions = slice.actions;

const commonPersistConfig = {
  key: PERSIST_KEYS.COMMON,
  storage,
  whitelist: ['platformData'],
};

export {
  commonActions,
};

export default persistReducer(commonPersistConfig, slice.reducer);
